import React from 'react'

export default function HomeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M2.66699 14V6L8.00033 2L13.3337 6V14H9.33366V9.33333H6.66699V14H2.66699Z'
        fill='currentColor'
      />
    </svg>
  )
}
